import { BsPersonCircle, BsCalendar, BsEnvelope, BsPhone, BsGeoAlt } from 'react-icons/bs';
import { motion } from "framer-motion";

const UserCard = ({ user, className = "" }) => {
  if (!user) return null;

  return (
    <motion.div
      className={`bg-gradient-to-br from-[#2a2a2a] to-[#1a1a1a] rounded-2xl shadow-2xl p-6 border border-[#3a3a3a] hover:border-[#9B8A61] transition-all duration-300 transform hover:scale-105 ${className}`}
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      whileHover={{ 
        boxShadow: "0 25px 50px -12px rgba(155, 138, 97, 0.25)",
        scale: 1.02 
      }}
    >
      {/* תמונת פרופיל */}
      <div className="relative mb-6 flex justify-center">
        <div className="w-20 h-20 bg-gradient-to-br from-[#9B8A61] to-[#D4AF37] rounded-full flex items-center justify-center shadow-lg">
          <BsPersonCircle className="w-12 h-12 text-white" />
        </div>
        {user.isEmailVerified && (
          <div className="absolute -top-1 -right-1 w-6 h-6 bg-emerald-500 rounded-full flex items-center justify-center">
            <span className="text-white text-xs font-bold">✓</span>
          </div>
        )}
      </div>

      {/* שם משתמש */}
      <div className="text-center mb-4">
        <h3 className="text-xl font-bold text-[#9B8A61] mb-1">
          {user.firstName} {user.lastName}
        </h3>
        <p className="text-gray-400 text-sm capitalize">
          {user.role === 'admin' ? 'מנהל מערכת' : 'לקוח'}
        </p>
      </div>

      {/* פרטי משתמש */}
      <div className="space-y-3">
        <div className="flex items-center text-gray-300">
          <BsEnvelope className="w-4 h-4 text-[#D4AF37] ml-2 flex-shrink-0" />
          <span className="text-sm truncate" title={user.email}>
            {user.email}
          </span>
        </div>

        {user.phone && (
          <div className="flex items-center text-gray-300">
            <BsPhone className="w-4 h-4 text-[#D4AF37] ml-2 flex-shrink-0" />
            <span className="text-sm">{user.phone}</span>
          </div>
        )}

        {user.address?.street && (
          <div className="flex items-center text-gray-300">
            <BsGeoAlt className="w-4 h-4 text-[#D4AF37] ml-2 flex-shrink-0" />
            <span className="text-sm truncate" title={`${user.address.street}, ${user.address.city || ''}`}>
              {user.address.street}, {user.address.city || ''}
            </span>
          </div>
        )}

        <div className="flex items-center text-gray-300">
          <BsCalendar className="w-4 h-4 text-[#D4AF37] ml-2 flex-shrink-0" />
          <span className="text-sm">
            נרשם ב-{new Date(user.createdAt).toLocaleDateString('he-IL')}
          </span>
        </div>
      </div>

      {/* תחתית כרטיס */}
      <div className="mt-6 pt-4 border-t border-[#3a3a3a]">
        <div className="flex items-center justify-between text-sm">
          <span className="text-gray-400">סטטוס חשבון:</span>
          <span className={`px-2 py-1 rounded-full text-xs font-medium ${
            user.isActive 
              ? 'bg-emerald-500 text-white' 
              : 'bg-red-500 text-white'
          }`}>
            {user.isActive ? 'פעיל' : 'לא פעיל'}
          </span>
        </div>
        
        {user.lastLogin && (
          <div className="flex items-center justify-between text-sm mt-2">
            <span className="text-gray-400">כניסה אחרונה:</span>
            <span className="text-gray-300 text-xs">
              {new Date(user.lastLogin).toLocaleDateString('he-IL')}
            </span>
          </div>
        )}
      </div>

      {/* אפקט hover גרדיאנט */}
      <div className="absolute inset-0 bg-gradient-to-br from-[#9B8A61]/5 to-[#D4AF37]/5 rounded-2xl opacity-0 hover:opacity-100 transition-opacity duration-300 pointer-events-none" />
    </motion.div>
  );
};

export default UserCard; 